import type { PropsWithChildren } from 'react';
import React from 'react';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'src/styling/global.scss';

import GlobalPageLayoutContent from 'src/components/layout/global-page-layout-content';
import GlobalContentProvider from 'src/content/global-content-provider';

import type { SnippetsProps } from './snippets';

type GlobalPageLayoutProps = PropsWithChildren<{
  snippets?: Partial<SnippetsProps>;
  globalCmsPageData: unknown;
}>;

const GlobalPageLayout = ({ globalCmsPageData, ...props }: GlobalPageLayoutProps) => {
  return (
    <GlobalContentProvider globalCmsPageData={globalCmsPageData}>
      <GlobalPageLayoutContent {...props} />
    </GlobalContentProvider>
  );
};

export default GlobalPageLayout;
